import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useAssociateContext } from '../../check-point-condition-list-gather/Contxt';
import { Radio, Select, Space } from 'udesk-ui';
import { NewAssociateComponent } from './normal';
import { AdvancedAssociate } from './advanced';
import { isQaSubApp, isSalesSubApp, isConversationAnalysis } from 'Udesk/system/subApp';
import './style.scss';

const useAssociateData = (props) => {
    const {
        type: typeInProps,
        isAutoAssociateDateSource = 1, // 是否自动选择随路数据的数据源，此处适用于销售赋能，默认为 1
        operatorItem,
    } = props;

    const [associateList, setAssociateList] = useState([]);
    const {
        associateList: defaultAssociateList,
        associateOperatorList,
        updateDataSearchTemplateByDynamicType,
    } = useAssociateContext();

    useEffect(() => {
        setAssociateList(defaultAssociateList);
    }, [defaultAssociateList]);

    const type = useMemo(() => {
        if (isAutoAssociateDateSource) {
            return typeInProps;
        }
        return operatorItem.operatorList[0].param?.inspectSource;
    }, [isAutoAssociateDateSource, operatorItem.operatorList, typeInProps]);

    useEffect(() => {
        // 销售赋能 关键事件之类的配置可以在算子内改变数据源
        if (!isAutoAssociateDateSource) {
            updateDataSearchTemplateByDynamicType(type).then((typeList) => {
                setAssociateList(typeList);
            });
        }
    }, [type, isAutoAssociateDateSource, updateDataSearchTemplateByDynamicType]);

    return [associateList, associateOperatorList];
};

export default React.memo((props) => {
    const {
        locales,
        isNewAssociate,
        isAutoAssociateDateSource,
        operatorItem,
        changeInputValue,
        handleOperatorItemChange,
        disabled,
        /** 用于工单信息字段 */
        isTicketField,
        /** 用于客户信息字段。*/
        isCustomerField,
        /**.用于预处理中 */
        isPreprocess,
    } = props;

    const isTicket = useMemo(() => {
        return props.type?.includes?.(Udesk.enums.inspectDataSources.ticket.id);
    }, [props.type]);

    const isMixed = useMemo(() => {
        return (props.type || []).includes(Udesk.enums.inspectDataSources.mixedType.id);
    }, [props.type]);

    const [_associateList, associateOperatorList] = useAssociateData(props);

    const changeHandle = useCallback(
        (event) => {
            return changeInputValue(operatorItem, 'inputContent', event);
        },
        [changeInputValue, operatorItem]
    );

    const onScopeChange = useCallback(
        (event) => {
            return changeInputValue(operatorItem, 'scope', event);
        },
        [changeInputValue, operatorItem]
    );

    const enumSelectChangeHandle = useCallback(
        (value) => {
            if (value) {
                operatorItem.operatorList[0].param.inspectSource = value;
                changeHandle('');
            }
        },
        [changeHandle, operatorItem.operatorList]
    );

    const onFallbackChange = useCallback(
        (value) => {
            return changeInputValue(operatorItem, 'isHitNotMatchSource', value);
        },
        [changeInputValue, operatorItem]
    );

    const selectOptions = useMemo(() => {
        if (isSalesSubApp()) {
            // 9, 13, 14
            return [
                Udesk.enums.inspectDataSources.reviewCall,
                Udesk.enums.inspectDataSources.salesWechatRadio,
                Udesk.enums.inspectDataSources.salesWechatText,
            ].map((item) => {
                return {
                    value: item.id,
                    label: item.name,
                };
            });
        } else if (isQaSubApp() || isConversationAnalysis()) {
            // 1, 2, 5, 10, 12
            let sorces = [
                Udesk.enums.inspectDataSources.voiceCall,
                Udesk.enums.inspectDataSources.textDialogue,
                Udesk.enums.inspectDataSources.wechatDialogue,
                Udesk.enums.inspectDataSources.ticket,
                Udesk.enums.inspectDataSources.wechatRadio,
            ];

            if (isMixed) {
                sorces = [
                    Udesk.enums.inspectDataSources.voiceCall,
                    Udesk.enums.inspectDataSources.textDialogue,
                    Udesk.enums.inspectDataSources.videoCall,
                    Udesk.enums.inspectDataSources.ticket,
                    Udesk.enums.inspectDataSources.survey,
                ];
            }

            if (isPreprocess && props.type.includes(0)) {
                sorces = [
                    Udesk.enums.inspectDataSources.voiceCall,
                    Udesk.enums.inspectDataSources.textDialogue,
                    Udesk.enums.inspectDataSources.videoCall,
                    Udesk.enums.inspectDataSources.taobao,
                ];
            }

            return sorces.map((item) => {
                return {
                    value: item.id,
                    label: item.name,
                };
            });
        } else {
            return [];
        }
    }, [isMixed, isPreprocess, props.type]);

    const associateList = useMemo(() => {
        return isTicketField
            ? _associateList.filter((item) => item.type === 15)
            : isCustomerField
            ? _associateList.filter((item) => item.type === 16)
            : _associateList.filter((item) => {
                  if (isMixed) {
                      if (
                          operatorItem.operatorList[0].param?.inspectSource ===
                          Udesk.enums.inspectDataSources.voiceCall.id
                      ) {
                          return item.type === 1 || item.type === 6 || item.type === 15;
                      } else if (
                          operatorItem.operatorList[0].param?.inspectSource ===
                          Udesk.enums.inspectDataSources.textDialogue.id
                      ) {
                          return item.type === 1 || item.type === 6 || item.type === 15;
                      } else if (
                          operatorItem.operatorList[0].param?.inspectSource ===
                          Udesk.enums.inspectDataSources.videoCall.id
                      ) {
                          return item.type === 1 || item.type === 6;
                      } else if (
                          operatorItem.operatorList[0].param?.inspectSource ===
                          Udesk.enums.inspectDataSources.ticket.id
                      ) {
                          return item.type === 1;
                      } else if (
                          operatorItem.operatorList[0].param?.inspectSource ===
                          Udesk.enums.inspectDataSources.survey.id
                      ) {
                          return item.type === 1;
                      } else {
                          return true;
                      }
                  } else if (isTicket) {
                      return item.type !== 16;
                  } else if (isPreprocess && props.type.includes(0)) {
                      if (
                          [
                              Udesk.enums.inspectDataSources.voiceCall.id,
                              Udesk.enums.inspectDataSources.textDialogue.id,
                          ].includes(operatorItem.operatorList[0].param?.inspectSource)
                      ) {
                          return (
                              item.type === 1 ||
                              item.type === 3 ||
                              item.type === 6 ||
                              item.type === 15 ||
                              item.type === 16
                          );
                      } else if (
                          [
                              Udesk.enums.inspectDataSources.videoCall.id,
                              Udesk.enums.inspectDataSources.taobao.id,
                          ].includes(operatorItem.operatorList[0].param?.inspectSource)
                      ) {
                          return item.type === 1 || item.type === 16;
                      } else {
                          return true;
                      }
                  } else {
                      return item.type !== 15 && item.type !== 24;
                  }
              });
    }, [
        _associateList,
        isCustomerField,
        isMixed,
        isTicket,
        isTicketField,
        operatorItem.operatorList,
        isPreprocess,
        props.type,
    ]);

    return (
        <Space align="start" wrap>
            {!isAutoAssociateDateSource && (
                <Select
                    style={{ minWidth: 100 }}
                    value={operatorItem.operatorList[0].param?.inspectSource}
                    onChange={enumSelectChangeHandle}
                    options={selectOptions}
                    disabled={disabled}
                />
            )}

            {isNewAssociate ? (
                <NewAssociateComponent
                    {...{
                        locales,
                        associateList,
                        value: operatorItem.operatorList[0].param?.inputContent,
                        onChange: changeHandle,
                        disabled,
                        isTicketField,
                        isCustomerField,
                        scope: operatorItem.operatorList[0].param?.scope,
                        onScopeChange,
                        isTicket,
                    }}
                />
            ) : (
                <AdvancedAssociate
                    {...{
                        locales,
                        operatorItem,
                        associateList,
                        associateOperatorList,
                        changeInputValue: changeHandle,
                        handleOperatorItemChange,
                        disabled,
                    }}
                />
            )}

            {(isMixed || (isPreprocess && props.type.includes(0))) &&
            !isTicketField &&
            !isCustomerField ? (
                <Space align="start">
                    <span>
                        {/* 非该数据源时算子命中结果 */}
                        {
                            UdeskLocales['current'].components.checkPointOperatorListGather
                                .associate.index.operatorHitResultWhenTheDataSourceIsNot
                        }
                    </span>
                    <Radio.Group
                        options={[
                            {
                                label: /* 是 */ UdeskLocales['current'].components
                                    .checkPointOperatorListGather.associate.index.yes,
                                value: 1,
                            },
                            {
                                label: /* 否 */ UdeskLocales['current'].components
                                    .checkPointOperatorListGather.associate.index.no,
                                value: 0,
                            },
                        ]}
                        value={operatorItem.operatorList[0].param?.isHitNotMatchSource}
                        onChange={(e) => onFallbackChange(e.target.value)}
                    />
                </Space>
            ) : null}
        </Space>
    );
});
